import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useModel } from "../hooks/modelcontex";
import {
  getBadges,
  getDataById,
  getPoemDetails,
  getProfileDetails,
  getStoryCategories,
  getStoryDetails,
  getUserportfolio,
  getUserportfolioPoem,
  getUserportfolioStory,
} from "./utilities/ApiCalls";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Layout from "../Layout/Layout";
import Default from "../Images/Defaultprofile.png";
import Constant, { statusFailure } from "./Constant";
import { Link2, Plus } from "lucide-react";
import axios from "axios";
import { getTokenDetails } from "../views/utilities/CommonFunction";
import { useTranslation } from "react-i18next";
import FlipBooks from "./FlipBooks";
import { setPageTitle } from "../utils/titleUtils";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const MyProfileDetails = () => {
  const [t] = useTranslation();
  const location = useLocation();

  useEffect(() => {
    setPageTitle(location.pathname);
  }, [location]);

  const [stories, setStories] = useState([]);
  const [poems, setPoems] = useState([]);
  const [profile, setProfile] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [length, setLength] = useState(1);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const [tab, settab] = useState("stories");
  const [portPoem, setPortPoem] = useState([]);
  const { Option, setFollowOptions } = useModel();
  const history = useHistory();
  const { Profilepic } = useModel();
  const [sharelink, setShareLink] = useState(false);
  const [userBadge, setUserBadge] = useState([]);
  const [badgeIds, setBadgeIds] = useState([]);
  const [link, setlink] = useState("");
  const [port, setPort] = useState([]);
  const [isHovered, setIsHovered] = useState(false);

  const divRef = useRef(null);

  // Consolidated profile and badge fetching
  useEffect(() => {
    const fetchProfileDetails = async () => {
      try {
        const response = await getProfileDetails();
        if (response.status !== statusFailure) {
          const profileData = response.data.data;
          setProfile(profileData);

          const userBadgeData = profileData.userBadge;
          if (userBadgeData) {
            if (userBadgeData.badgeDetails?.length) {
              setUserBadge(userBadgeData.badgeDetails);
            } else {
              setBadgeIds(userBadgeData.badgeIds || []);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching profile details:", error);
      }
    };

    fetchProfileDetails();
  }, []);

  // Badges fetching
  const fetchBadges = async () => {
    try {
      if (badgeIds && badgeIds.length > 0) {
        const badgeResponses = await Promise.all(
          badgeIds.map(async (id) => {
            const response = await getBadges(id);
            // Check if response contains empty data array but success status
            if (
              response.data &&
              response.data.status === "Success" &&
              (response.data.data === null ||
                (Array.isArray(response.data.data) &&
                  response.data.data.length === 0))
            ) {
              return null; // Return null for empty data
            }
            return response.data;
          })
        );

        // Filter out null responses and empty data
        const validBadges = badgeResponses
          .filter(Boolean)
          .filter(
            (badge) =>
              badge.data &&
              (Array.isArray(badge.data) ? badge.data.length > 0 : true)
          );

        setUserBadge(validBadges);
      }
    } catch (error) {
      console.error("Error getting user Badges:", error);
      setUserBadge([]);
    }
  };

  useEffect(() => {
    fetchBadges();
  }, [badgeIds]);

  // Click outside handler for share link
  const handleClickOutside = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      setShareLink(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  async function portfolioFetch() {
    console.log("Fetching portfolio...");
    try {
      const response = await getUserportfolio(profile._id);
      console.log("Portfolio response", response.data);

      let editedPort = [];

      try {
        // Process data to split long descriptions
        editedPort = response.data.flatMap((item) => {
          if (item.eventId && item.eventId.description) {
            const description = item.eventId.description;
            const maxLength = 600;

            if (description.length > maxLength) {
              const pages = [];
              let remainingText = description;

              while (remainingText.length > maxLength) {
                pages.push({
                  ...item,
                  eventId: {
                    ...item.eventId,
                    description: remainingText.slice(0, maxLength),
                  },
                });
                remainingText = remainingText.slice(maxLength);
              }

              // Add the last part of the description
              pages.push({
                ...item,
                eventId: {
                  ...item.eventId,
                  description: remainingText,
                },
              });

              return pages;
            }
          }

          // If description is within the limit, return the item as is
          return item;
        });

        console.log("Processed portfolio data:", editedPort);
      } catch (processingError) {
        console.error("Error during data processing:", processingError);
        // Fall back to original data
        editedPort = response.data;
      }

      // Update state
      setPort(editedPort);
      console.log("State update triggered");

      return editedPort;
    } catch (error) {
      console.error(
        "Portfolio fetch error:",
        error.response ? error.response.data : error.message
      );
      return null;
    }
  }
  

  // Handlers for follows and content fetching
  const HandleClickFollows = () => {
    setFollowOptions("followers");
    history.push(`/userFollowers/${profile._id}`);
  };

  const HandleClickFollowing = () => {
    setFollowOptions("following");
    history.push(`/userFollowers/${profile._id}`);
  };

  function getUserStories() {
    let params = {
      userId: profile._id,
      user_id: profile._id,
    };
    getStoryDetails(params)
      .then((response) => {
        setStories(response.data);
        setPageNo(response.pageNo);
        setLength(response.length);
      })
      .catch((error) => {
        console.error("Error fetching stories:", error);
      });
  }

  function getUserPoems(page, categoryId) {
    let params = { moduleType: 2 };
    getStoryCategories(params).then((response) => {
      setCategories(response.data);
    });

    params = {
      userId: profile._id,
      user_id: profile._id,
      pageNo: page || pageNo,
    };

    if (categoryId) {
      params.categoryId = categoryId;
      setCategoryId(categoryId);
    } else {
      setCategoryId("");
    }

    getPoemDetails(params)
      .then((response) => {
        setPoems(response.data);
        setPageNo(response.pageNo);
        setLength(response.length);
      })
      .catch((error) => {
        console.error("Error fetching poems:", error);
      });
  }

  // Initial stories fetch
  useEffect(() => {
    if (profile._id) {
      getUserStories();
    }
  }, [profile]);

  // Clipboard copy function
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      console.log("Link copied:", text);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <Layout>
      <Root tab={tab}>
        <div className={`profile-container  ${sharelink && "opacity"} `}>
          <div className="profile-image">
            <img
              alt="profileImage"
              className="img"
              crossOrigin="anonymous"
              src={profile.profilePic ? Profilepic : Default}
            />
            <div className="user-details">
              <div className="Name">{profile.name}</div>

              {/* Badges Section */}
              <div className="badge-icons">
                {userBadge && userBadge.length > 0 ? (
                  userBadge.map((badge, index) => (
                    <div className="badge-container" key={index}>
                      <img
                        src={badge.icon}
                        alt={badge.title}
                        className="badge-icon"
                        crossOrigin="anonymous"
                      />
                      <div className="tooltip">{badge.title}</div>
                    </div>
                  ))
                ) : (
                  <div className="no-badges">No Badges</div>
                )}
              </div>

              <div className="follow-text">
                <span
                  style={{ cursor: "pointer" }}
                  onClick={HandleClickFollows}
                >
                  {profile?.followersList?.length || "0"}{" "}
                  {t("Profile.Followers")}
                </span>{" "}
                <span> • </span>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={HandleClickFollowing}
                >
                  {" "}
                  {profile?.followingList?.length || "0"}{" "}
                  {t("Profile.Following")}{" "}
                </span>
              </div>

              <div className="button">
                <button
                  onClick={() => {
                    setShareLink(true);
                    setlink(
                      `https://www.storytent.in/userprofile/${profile._id}`
                    );
                  }}
                  className="btn"
                >
                  {t("Profile.Share")}
                </button>
                <Link to={`/setting/edit`}>
                  <button className="btn">{t("Profile.EditProfile")}</button>
                </Link>
              </div>
            </div>

            <div className="tab">
              <div
                onClick={() => {
                  settab("stories");
                  getUserStories();
                }}
                className="story-tab-title"
              >
                {t("Profile.Stories")}
              </div>
              <div
                onClick={() => {
                  settab("poetries");
                  getUserPoems();
                }}
                className="poem-tab-title"
              >
                {t("Profile.Poetries")}
              </div>
              <div
                onClick={() => {
                  settab("portfolio");
                  portfolioFetch();
                }}
                className="profile-tab-title"
              >
                {t("Profile.Portfolio")}
              </div>
            </div>
          </div>

          <div className="tab-content">
            {tab === "stories" &&
              stories.length > 0 &&
              stories.map((data) => (
                <Link key={data._id} to={`/story-details/${data._id}`}>
                  <div className="cart">
                    <div className="img-contiainer">
                      <img
                        src={data.thumbnail}
                        alt="thumbnail"
                        className="thumbnail"
                      />
                      <div className="hover-text">
                        <p
                          className="content"
                          dangerouslySetInnerHTML={{ __html: data.description }}
                        ></p>
                      </div>
                    </div>
                    <div className="title">{data.name} </div>
                  </div>
                </Link>
              ))}

            {tab === "poetries" &&
              poems.length > 0 &&
              poems.map((data) => (
                <Link key={data._id} to={`/poem-details/${data._id}`}>
                  <div className="cart">
                    <div className="img-contiainer">
                      <img
                        src={data.thumbnail}
                        alt="thumbnail"
                        className="thumbnail"
                      />
                      <div className="hover-text">
                        <p
                          className="content"
                          dangerouslySetInnerHTML={{ __html: data.description }}
                        ></p>
                      </div>
                    </div>
                    <div className="title">{data.name}</div>
                  </div>
                </Link>
              ))}

            {tab === "portfolio" && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100vw",
                  textAlign: "center",
                }}
              >
                {port.length > 0 ? (
                  <FlipBooks data={port} />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    {t("Profile.NoPortfolio")}
                  </div>
                )}
              </div>
            )}
          </div>

          {tab === "stories" && stories.length === 0 && (
            <div>{t("Profile.NoStory")}</div>
          )}

          {tab === "poetries" && poems.length === 0 && (
            <div style={{ textAlign: "center" }}>{t("Profile.NoPoetry")} </div>
          )}
        </div>

        {sharelink && (
          <div ref={divRef} className="share-box">
            <div
              onClick={() => setShareLink(false)}
              style={{ position: "absolute", right: "0px", cursor: "pointer" }}
            >
              <Plus style={{ transform: "rotate(45deg)", color: "white" }} />
            </div>
            <div
              style={{ textAlign: "center", color: "white", fontSize: "20px" }}
            >
              Share
            </div>
            <div className="share-link-icon">
              <span
                onClick={() => {
                  copyToClipboard(link);
                  setShareLink(false);
                }}
                style={{ cursor: "pointer" }}
                className="icon-container"
              >
                <Link2 />
              </span>
            </div>
            <div
              style={{
                textAlign: "center",
                color: "white",
              }}
            >
              Copy Link
            </div>
          </div>
        )}
      </Root>
    </Layout>
  );
};

export default MyProfileDetails;

const Root = styled.div`
  max-weight: 1300px;
  min-height: 100vh;
  background-color: #0f1817;
  display: flex;

  justify-content: center;
  position: relative;
  height: auto;

  /* Badge container styles */
  /* Badge container styles */
  .badge-icons {
    display: flex;
    align-items: center;
    margin: 10px 0;
  }

  .badge-container {
    position: relative;
    display: inline-block;
    cursor: pointer;
    margin-right: -12px; /* This creates the overlapping effect */
    z-index: 1;
    transition: z-index 0s, transform 0.2s ease;
  }

  .badge-container:hover {
    border-color: white;
    transform: scale(1.1);
  }

  /* Badge image styles */
  .badge-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 2px solid #0f1817; /* Match your background color */
    transition: transform 0.2s ease;
  }

  /* Tooltip styles */
  .tooltip {
    visibility: hidden;
    position: absolute;
    background-color: #07262b;
    color: white;
    text-align: center;
    border-radius: 6px;
    padding: 5px 10px;
    font-size: 12px;
    white-space: nowrap;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 8px;
    z-index: 100;
    opacity: 1;
    transition: opacity 0.3s;
  }

  /* Tooltip arrow */
  .tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
  }

  /* Show the tooltip on hover */
  .badge-container:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
  .badge-container:hover .badge-icon {
    border: 2px solid white; /* Match your background color */
  }
  .icon-name {
    background-color: black;
    color: white;
    margin-top: 5px;
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 2px;
    position: absolute;
  }
  .Name {
    font-size: 25px;
    color: white;
    margin-top: 10px;
  }

  .badge-popup {
    width: 200px;
    height: 100px;
    border-radius: 20px;
    color: white;
    display: flex;
    align-item: center;
    justify-content: center;
    background-color: red;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .profile-container {
    width: 100%;
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .icon-container {
    background-color: #e6edea;
    padding: 10px;
    padding-left: 12px;
    padding-right: 12px;
    border-radius: 100px;
  }

  .hover-text {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    opacity: 0;
    line-height: 1.2; /* Adjust line height as needed */
    letter-spacing: -0.6px; /* Adjust letter spacing as needed */
    overflow: hidden;
    text-align: center;
    white-space: normal;
    text-overflow: ellipsis;
    &:hover {
      opacity: 1; /* Display when hovered */
      background-color: rgba(0, 0, 0, 0.7);
    }

    @media (min-width: 350px) and (max-width: 600px) {
      font-size: 15px;
    }
  }

  .hover-text {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    border-radius: 20px;
    opacity: 0;
    overflow: hidden;
    padding: 0 10px;
    &:hover {
      opacity: 1; /* Display when hovered */
      background-color: rgba(0, 0, 0, 0.7);
    }
  }

  .content {
    letter-spacing: -0.5px; /* Adjust as needed */
    font-size: 14px; /* Adjust as needed */
    overflow: hidden;
    color: white;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }

  .thumbnail {
    ${
      "" /* width:100%;
    height:80%; */
    }
    width:250px;
    height: 150px;
    border-radius: 10px;

    @media (min-width: 350px) and (max-width: 400px) {
      height: 120px;
    }
  }

  .badges {
    display: flex;
    margin-top: 10px;
    color: white;
    gap: 10px;
  }

  .title {
    margin-left: 5px;
    ${"" /* height:100px; */}
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* Limits the text to two lines */
    line-clamp: 1; /* Not yet standard, but good to include */
    white-space: normal; /* Allow text to wrap to the next line */
    width: 90%;
    color: white;
    margin-top: 5px;
    line-height: 1;
    text-transform: capitalize;
    @media (min-width: 350px) and (max-width: 500px) {
      font-size: 10px;
      width: 90%;
    }

    @media (min-width: 701px) and (max-width: 900px) {
      font-size: 10px;
      width: 90%;
    }
  }

  .share-link-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .share-box {
    width: 300px;
    background-color: #023020;
    height: 120px;
    border-radius: 10px;
    position: fixed;
    top: 400px;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .hover-text {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    opacity: 0;
    line-height: 1.2; /* Adjust line height as needed */
    letter-spacing: -0.6px; /* Adjust letter spacing as needed */
    overflow: hidden;
    text-align: center;
    white-space: normal;
    text-overflow: ellipsis;
    &:hover {
      opacity: 1; /* Display when hovered */
      background-color: rgba(0, 0, 0, 0.7);
    }

    @media (min-width: 350px) and (max-width: 600px) {
      font-size: 15px;
    }
  }

  .bio {
    margin-top: 20px;
    color: white;
    text-align: center;
  }

  .cart {
    height: auto;
    width: 100%;
    min-width: 250px;
    max-width: 250px;
    min-height: 100px;
    @media (min-width: 350px) and (max-width: 550px) {
      min-width: 150px;
    }
  }

  .img-contiainer {
    height: 80%;
    width: 100%;
    position: relative;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .img-thumbnail {
    width: 250px;
    height: 150px;
    border-radius: 10px;

    @media (min-width: 350px) and (max-width: 400px) {
      height: 120px;
    }
  }

  .tab-content {
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 10px;
    grid-row-gap: -20px;
    justify-content: center;
    align-items: center;

    margin-top: 50px;
    @media (min-width: 350px) and (max-width: 780px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 781px) and (max-width: 1150px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .story-tab-title {
    color: white;
    font-size: 15px;
    text-decoration: ${(props) =>
      props.tab === "stories" ? "underline " : "none"};
    text-underline-offset: 12px; /* Adjust the value to increase space between text and underline */
    text-decoration-thickness: 3px;
    cursor: pointer;
  }

  .profile-tab-title {
    color: white;
    font-size: 15px;
    text-decoration: ${(props) =>
      props.tab === "portfolio" ? "underline" : "none"};
    text-underline-offset: 12px; /* Adjust the value to increase space between text and underline */
    text-decoration-thickness: 3px;
    cursor: pointer;
  }

  .poem-tab-title {
    color: white;
    font-size: 15px;
    text-decoration: ${(props) =>
      props.tab === "poetries" ? "underline" : "none"};
    text-underline-offset: 12px; /* Adjust the value to increase space between text and underline */
    text-decoration-thickness: 3px;
    cursor: pointer;
  }

  .tab {
    display: flex;
    margin-top: 75px;
    gap: 20px;
  }

  .btn {
    background-color: #263a38;
    color: white;
    border-radius: 30px;
    font-size: 10px;
  }

  .button {
    display: flex;
    gap: 20px;
    margin-top: 10px;
  }

  .follow-text {
    font-size: 18px;
    margin-top: 5px;
  }

  .user-details {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .profile-image {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .img {
    border-radius: 100px;
    width: 200px;
    height: 200px;
  }
`;
